import { useState } from 'react';
import { constants } from '../../constants';
import { IssuerDescriptionPopup } from './IssuerDescriptionPopup';

interface IssuerDescriptionProps {
    issuer: string;
    issuerDescription?: string;
}

export function IssuerDescription({ issuer, issuerDescription }: IssuerDescriptionProps) {
    const [visible, setVisible] = useState(false);

    if (!issuerDescription) return <>{constants.emptyPlaceholder}</>;

    return (
        <>
            <button className="pseudo-link" onClick={() => setVisible(true)}>
                View
            </button>
            {visible && (
                <IssuerDescriptionPopup
                    issuer={issuer}
                    issuerDescription={issuerDescription}
                    onClose={() => setVisible(false)}
                />
            )}
        </>
    );
}
